
import React from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import { Wifi, Car, AirVent, Shield, Waves, Dumbbell, TreePine, Camera, Utensils, WashingMachine } from 'lucide-react';

interface PropertyAmenitiesDisplayProps {
  amenities: string[];
}

const PropertyAmenitiesDisplay = ({ amenities }: PropertyAmenitiesDisplayProps) => {
  const { t } = useLanguage();

  const amenityConfig = {
    wifi: {
      icon: Wifi,
      label: {
        en: 'WiFi',
        ar: 'واي فاي'
      }
    },
    parking: {
      icon: Car,
      label: {
        en: 'Parking',
        ar: 'موقف سيارات'
      }
    },
    ac: {
      icon: AirVent,
      label: {
        en: 'Air Conditioning',
        ar: 'تكييف'
      }
    },
    security: {
      icon: Shield,
      label: {
        en: 'Security',
        ar: 'أمن'
      }
    },
    pool: {
      icon: Waves,
      label: {
        en: 'Swimming Pool',
        ar: 'حمام سباحة'
      }
    },
    gym: {
      icon: Dumbbell,
      label: {
        en: 'Gym',
        ar: 'صالة ألعاب رياضية'
      }
    },
    garden: {
      icon: TreePine,
      label: {
        en: 'Garden',
        ar: 'حديقة'
      }
    },
    cctv: {
      icon: Camera,
      label: {
        en: 'CCTV',
        ar: 'كاميرات مراقبة'
      }
    },
    kitchen: {
      icon: Utensils,
      label: {
        en: 'Kitchen',
        ar: 'مطبخ'
      }
    },
    laundry: {
      icon: WashingMachine,
      label: {
        en: 'Laundry',
        ar: 'غسيل'
      }
    }
  };

  const currentLanguage = t('lang_code', 'ar', 'en') as 'en' | 'ar';

  if (!amenities || amenities.length === 0) {
    return null;
  }

  return (
    <div className="bg-card rounded-lg p-6 border">
      <h3 className="text-lg font-semibold mb-4">
        {t('amenities', 'المرافق', 'Amenities')}
      </h3>
      
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
        {amenities.map((amenityId) => {
          const amenity = amenityConfig[amenityId as keyof typeof amenityConfig];
          if (!amenity) return null;
          
          const IconComponent = amenity.icon;
          
          return (
            <div key={amenityId} className="flex items-center space-x-2 rtl:space-x-reverse">
              <IconComponent className="h-4 w-4 text-primary" />
              <span className="text-sm">{amenity.label[currentLanguage]}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PropertyAmenitiesDisplay;
